module.exports = __webpack_public_path__ + "ea594a1f/img/layout-2.5afd4b42.jpg";